import errors from './errors/index.js';
import translation from './translation/index.js';
const en = {
    translation,
    errors,
};
export default Object.freeze(en);
